import { BreachEvent } from '@news-mono/web-common'
import React from 'react'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import BlackFridayBreachContent from './BlackFridayBreachContent'
import { StyledWestRewardsMessage } from './BlackFridayComponents/BlackFridayWestRewardsMessage.styled'
export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
}

export function BlackFridayBreachNotification({
    breachDeal,
    breachCreativeName,
    onEvent,
}: BreachNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BlackFridayBreachContent
                breachDeal={breachDeal}
                breachCreativeName={breachCreativeName}
                onEvent={onEvent}
                title="50% off subscriptions"
                message={
                    <p>
                        Black Friday Sale on now.
                        <br /> Ends midnight, Monday.
                    </p>
                }
                cta="View Packages"
                subscriptionPackages={[
                    {
                        ribbonTitle: '50% Off',
                        packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI1',
                        offerCode: 'BLKFRI1',
                        pretitle: 'Digital',
                        originalPrice: '$1 per day',
                        heading: 'Everyday Digital',
                        price: '50c  per day',
                        priceQualifier: 'for 8 weeks*',
                        packageType: 'digital',
                        cancellationMessage: 'Cancel anytime. 4 weeks minimum.',
                        googleSKU: 'everyday_digital_4weeks',
                        weeklyPrice: 7,
                        weeklyDiscount: 2.8,
                        rateCode: 'WST_DIGI_$4.20X8W_DD',
                    },
                    {
                        ribbonTitle: '50% Off',
                        pretitle: 'Digital & Print',
                        heading: 'Weekend Papers + Everyday Digital',
                        originalPrice: '$9 per week',
                        price: '$4.50 per week',
                        priceQualifier: 'for 8 weeks*',
                        packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI2',
                        offerCode: 'BLKFRI2',
                        packageType: 'digitalprint',
                        cancellationMessage: 'Cancel anytime. 4 weeks minimum.',
                        weeklyPrice: 9,
                        weeklyDiscount: 3.6,
                        rateCode: 'WST_SS+DIG4.50X8W_DD',
                    },
                ]}
            />
            <StyledWestRewardsMessage />
        </div>
    )
}
